"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _it = _interopRequireDefault(require("../i18n/it.json"));

var _domains = require("../helpers/domains");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEO_SRP_SPECS = {
  home: {
    main: {
      title: _defineProperty({}, _domains.DOMAIN_CASA, {
        it: _it["default"].IDS_SEO_TT_HP_CASAIT
      }),
      description: _defineProperty({}, _domains.DOMAIN_CASA, {
        it: _it["default"].IDS_SEO_DR_HP_CASAIT
      }),
      h1: _defineProperty({}, _domains.DOMAIN_CASA, {
        it: _it["default"].IDS_SEO_H1_HP_CASAIT
      }),
      h2: _defineProperty({}, _domains.DOMAIN_CASA, {
        it: _it["default"].IDS_SEO_H2_HP_CASAIT
      })
    }
  }
};
var _default = SEO_SRP_SPECS;
exports["default"] = _default;